import {Dialog} from '../../ui/dialog';
import {ElObj} from '../../elobj';
import {FancyPushButton} from '../../ui/pushbutton';
import {OBJ, Obj, SLOT} from '../../obj';
import {getLogger} from '../../logging';

const logger = getLogger('paymenterror');

const DEFAULT_TITLE = 'Payment unavailable';
const DEFAULT_MESSAGE = 'Payment could not be started. Please try again.';

// Pulls a structured `{error: {code, message}}` body out of an axios
// rejection. Falls back to a generic message if the response shape is
// not what the backend produces.
export function paymentErrorMessage(err: any): string {
	const response = err && err.response;
	const data = response && response.data;
	const inner = data && data.error;
	if (inner && typeof inner.message === 'string' && inner.message.length > 0) {
		return inner.message;
	}
	return DEFAULT_MESSAGE;
}

@OBJ
class PaymentErrorDialog extends Obj {
	private dialog: Dialog | null;

	constructor(message: string, title: string) {
		super();
		this.dialog = new Dialog({title});
		const body = new ElObj({
			classNames: 'lb-payment-error-body',
			tagName: 'div',
		});
		body.setText(message);
		this.dialog.appendElObj(body);
		const buttonBox = new ElObj({
			classNames: 'lb-button-box',
			tagName: 'div',
		});
		const okButton = new FancyPushButton({
			filled: true,
			parent: buttonBox,
			text: 'OK',
		});
		Obj.connect(okButton, 'clicked', this, 'dismiss');
		Obj.connect(this.dialog, 'closed', this, 'closed');
		this.dialog.appendElObj(buttonBox);
	}

	open(): void {
		if (this.dialog) {
			this.dialog.open();
		}
	}

	@SLOT
	private closed(): void {
		this.dialog = null;
		this.destroy();
	}

	@SLOT
	private dismiss(): void {
		if (this.dialog) {
			this.dialog.close();
		}
	}
}

// Opens a minimal dialog (title + body + OK button) reporting a
// pre-PaymentIntent failure. Reaches the same place as the post-Stripe
// failure path in PaymentDialogView.endPayment, but without depending on
// a clientSecret we never got.
export function showPaymentError(message: string, title?: string): void {
	logger.warning('showPaymentError: %s', message);
	const ctrl = new PaymentErrorDialog(message, title || DEFAULT_TITLE);
	ctrl.open();
}
